export default "__VITE_ASSET__COEChcH7__"